import type { LayoutType } from 'types';
import type { TemplateFormsState } from '../index';
import type { ConditionAttribute } from 'types/helios/templateForms';

export interface Payload {
  name: string;
  layoutType: LayoutType;
  conditions: ConditionAttribute[];
}

export const setSectionConditions = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { name, layoutType, conditions } = payload;
  const sections = state[layoutType].sections;

  const sectionIndex = sections.findIndex((section) => section.name === name);

  if (sectionIndex !== -1) {
    state[layoutType].sections[sectionIndex].defaultConditionAttributes = conditions;
  }
};
